<template>
  <nav class="umf-nav">
    <div class="nav-back"
         v-if="!hideBack"
         @click="navBack">
    </div>
    <slot v-else />
    <div class="title">{{title}}</div>
  </nav>
</template>

<script>
export default {
  name: 'UmfNav',

  props: {
    title: {
      type: String,
      default: ''
    },
    hideBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    navBack () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.umf-nav {
  height: 0.9rem;
  overflow: hidden;
  position: relative;
  .nav-back {
    // background-color: #999;
    position: absolute;
    left: 0;
    top: 0;
    background-image: url(~images/base/back.png);
    background-size: 0.18rem auto;
    background-position: right center;
    background-repeat: no-repeat;
    width: 0.6rem;
    height: 100%;
    cursor: pointer;
  }
  .title {
    text-align: center;
    font-size: 0.28rem;
    line-height: 0.9rem;
    color: #787878;
    background: #ffffff;
    font-family: "PingFang SC", "STHeitiSC-Light", "Helvetica-Light", arial,
      sans-serif, "Droid Sans Fallback";
  }
}
</style>